$(function () {
  function initChosen() {
    if (Reverb.MobileDetection.isMobileBrowser()) {
      return;
    }

    $('select.chosen-select, [data-chosen-select]').chosen({
      disable_search_threshold: 10,
      placeholder_text_single: ' ',
      placeholder_text_multiple: ' '
    });

    $('select.chosen-select-no-search').chosen({
      disable_search: true,
      placeholder_text_single: ' ',
      placeholder_text_multiple: ' '
    });
  }

  initChosen();

  $(document).bind('ajaxComplete', initChosen);
});



// WEBPACK FOOTER //
// ./javascripts/components/legacy/init/chosen.js